import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components/macro';
import { Card, List } from 'antd';

export const EmptyCard = ({
  title,
  onCreateNewItem,
}: {
  title?: string;
  onCreateNewItem: () => void;
}) => {
  const themeContext = useContext(ThemeContext);
  return (
    <List.Item key={0}>
      <StyledEmptyCard theme={themeContext} onClick={() => onCreateNewItem()}>
        <Plus>+</Plus>
        {title}
      </StyledEmptyCard>
    </List.Item>
  );
};

const Plus = styled.div`
  font-size: 2rem;
  line-height: 2rem;
`;

const StyledEmptyCard = styled(Card)`
  color: ${(p) => p.theme.colors.primary};
  border: dotted 2px #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: transparent;
  border-radius: 5px;
  height: 150px;
  width: 300px;
  cursor: pointer;
  transition: all 250ms linear;
  font-weight: 600;

  &:hover {
    background-color: #fff;
    color: #000;
  }
`;
